import { render, staticRenderFns } from "./market.vue?vue&type=template&id=378abae4&scoped=true&"
var script = {}
import style0 from "./market.vue?vue&type=style&index=0&id=378abae4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378abae4",
  null
  
)

export default component.exports